import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import DesignImage1 from "../../images/niradhi/design-1.png"
import DesignImage2 from "../../images/niradhi/design-2.png"
import DesignImage3 from "../../images/niradhi/design-3.png"

const Design = () => {
  return (
    <div className="py-5 additional-top-padding">
      <Container>
        <Row className="py-5">
          <Col
            md={{ span: 6, order: "first" }}
            sm={{ span: 12, order: "last" }}
          >
            <img src={DesignImage1} className="w-100" alt="niradhi/design-1" />
          </Col>
          <Col
            md={{ span: 6, order: "last" }}
            sm={{ span: 12, order: "first" }}
          >
            <div className="title d-flex h-100 w-100 justify-content-center align-items-center">
              Let the logo do the talking
            </div>
          </Col>
        </Row>
        <img src={DesignImage2} className="w-100 py-5" alt="niradhi/design-2" />
        <Row className="py-5">
          <Col md={6} sm={12}>
            <div className="title d-flex h-100 w-100 justify-content-start align-items-center text-left">
              Unconventional visual identity
            </div>
          </Col>
          <Col md={6} sm={12}>
            <img src={DesignImage3} className="w-100" alt="niradhi/design-3" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Design
